import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type UserLevel = 'SUPER_ADMIN' | 'SYS_ADMIN' | 'DEPT_HEAD' | 'STAFF';

export interface CurrentUser {
  id: number;
  username: string;
  name: string;
  level: UserLevel;
  departmentId: number | null;
  passwordMustChange: boolean;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: CurrentUser | null;
  setSession: (data: {
    accessToken: string;
    refreshToken: string;
    user: CurrentUser;
  }) => void;
  setAccessToken: (token: string) => void;
  setUser: (user: CurrentUser) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setSession: ({ accessToken, refreshToken, user }) =>
        set({ accessToken, refreshToken, user }),
      setAccessToken: (token) => set({ accessToken: token }),
      setUser: (user) => set({ user }),
      logout: () =>
        set({ accessToken: null, refreshToken: null, user: null }),
    }),
    {
      name: 'dfrc-auth',
      partialize: (s) => ({
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        user: s.user,
      }),
    },
  ),
);
